<template>
  <div class="gallery-item">
    <div class = "action">
      <slot name = "action"></slot>
    </div>

    <router-link :to="{ name: 'Editor.load', params: {projectId: galleryItem.id} }">
      <p class = "type" v-if = "galleryItem.type">{{galleryItem.type}}</p>
      <!--<p>{{galleryItem}}</p>-->

      <div class = "badge" v-if = "false">
        <slot name = "badge"></slot>
      </div>

      <div class = "cover">
        <img v-if = "galleryItem.cover === null" src = "/static/img/nocover.png" />
        <img v-else :src = "galleryItem.cover"/>
        <div class = "more-info">
          <p class = "author">{{owner}}</p>
          <p class = "type">{{galleryItem.config.type}}</p>
        </div>
      </div>

      <p class = "name">{{galleryItem.name}}</p>
    </router-link>

  </div>
</template>

<script>
export default {
  name: 'GalleryItem',
  props: {
    galleryItem: Object
  },
  computed: {
    owner: function () {
      if (this.galleryItem.owner) {
        return this.galleryItem.owner.name
      } else {
        return '?'
      }
    }
  },
  methods: {
  }
}
</script>

<style lang = "less" scoped>
@import (reference) "../../assets/styles/main.less";

@media (max-width: @breakPoint) {
  .cover {
    height: unset !important;
  }
}

a {
  padding: 0;
}

.gallery-item {
  background: transparent;
  position: relative;
  width: 100%;
  .font-code;
}

.cover {
  height: 192px;
  border-radius: 3px;
  background: #ccc;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    // width: 100%;
    // height: 100%;
  }

  &:hover {
    outline: 10px solid @accentColor;

    .more-info {
      display: block;
    }
  }

  .more-info {
    display: none;
    position: absolute;
    background: #0008;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 10px;

    .author {
      font-weight: 800;
      color: white;
    }

    .type {
      background: purple;
      color: white;
      padding: 5px;
      font-size: 0.8em;
      display: inline;
    }
  }
}

.name {
  padding: 10px;
  text-align: center;
  color: gray;
  font-weight: 500;
  color: @primaryTextColor;
  font-weight: 500;
  letter-spacing: -1px;
  font-size: 0.9em;
}

.badge {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  padding: 2px 5px;
  border-radius: 2px;
  margin: 10px;
  color: black;
  background: @accentColor;
}
.action {
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 1;
}

</style>



// WEBPACK FOOTER //
// src/components/Gallery/GalleryItem.vue